import dayjs   from "dayjs";
import dynamic from "next/dynamic";

import VideoBlockedView from "_components/atoms/videoEmptyView/blockedView";
import EndView          from "_components/atoms/videoEmptyView/endView";

const VideoPlayer = dynamic ( () => import ( "_components/features/player" ) );

const component = props => {
	const {
		broadcastData,
		sessionData,
		isStreamer,
		theatreModeToggle,
		handleTheatreMode,
		isBlockedByStreamer,
		isProStream,
		proDetails,
		streamTier
	} = props;

	const { liveViews, hasEnded } = sessionData;
	const {
		cdnUrl, streamingURL,
		sessionInfo, endTimeUTC,
		startTimeUTC, thumbnail,
		seekFeatureEnabled,
		restrictStreamQualityOnDesktop
	} = broadcastData;

	const startedAt      = dayjs ( dayjs.utc ( startTimeUTC ) ).unix ();
	const __cdnURL       = sessionData.cdnUrl && ( sessionData.cdnUrl !== cdnUrl ) ? sessionData.cdnUrl : cdnUrl;
	const isLive         = endTimeUTC ? false : true;
	const streamLink     = endTimeUTC ? streamingURL : __cdnURL;
	const __streamingURL = sessionData.streamingURL && ( sessionData.streamingURL !== streamingURL ) ? sessionData.streamingURL : streamingURL;

	if ( !hasEnded && isBlockedByStreamer )
		return <VideoBlockedView />;

	if ( hasEnded )
		return (
			<EndView />
		);

	let sessionType     = isLive ? "live" : "recorded";
	let sessionDuration = 0;

	if ( !isLive ) {
		sessionDuration = new Date ( endTimeUTC ).getTime () - new Date ( startTimeUTC ).getTime ();
		sessionDuration = sessionDuration / 1000;
	}

	return (
		<VideoPlayer
			adExtConfig          = { broadcastData?.adExtnDetail }
			enableAds            = { broadcastData?.showAds ?? true }
			handleTheatreMode    = { handleTheatreMode }
			isLive               = { isLive }
			isProStream          = { isProStream }
			isStreamer           = { isStreamer }
			liveViews            = { liveViews }
			proDetails           = { proDetails }
			readTime             = { sessionDuration }
			remainingAdCount     = { broadcastData.midTierRemainingAdWatchCount }
			restrictQuality      = { restrictStreamQualityOnDesktop }
			seekFeature          = { seekFeatureEnabled }
			sessionInfo          = { sessionInfo }
			sessionType          = { sessionType }
			src                  = { streamLink }
			startedAt            = { startedAt }
			streamerUserId       = { broadcastData?.broadcaster?.sportsFan?.id }
			streamTier           = { streamTier }
			theatreModeToggle    = { theatreModeToggle }
			thumbnail            = { thumbnail }
			vodSrc               = { __streamingURL }
		/>
	);
};

export default component;
